import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=83a3dce0&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/follow-book_follow-book-admin_fMUT/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83a3dce0')) {
      api.createRecord('83a3dce0', component.options)
    } else {
      api.reload('83a3dce0', component.options)
    }
    module.hot.accept("./Edit.vue?vue&type=template&id=83a3dce0&", function () {
      api.rerender('83a3dce0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Book/Edit.vue"
export default component.exports